import Icon from "../../Foundation/Icons";
import { ChipIconProps } from "./interface";

const ChipIcon = ({
    isActive,
    iconName,
    iconType,
    colour,
    secondaryColour,
    size,
}: ChipIconProps) => {
    if (!isActive) {
        return null;
    }
    return (
        <Icon
            colour={colour}
            secondaryColour={secondaryColour}
            name={iconName}
            ariaHidden={true}
            type={iconType}
            size={size}
        />
    );
};

export default ChipIcon;
